import { createContext, Dispatch, SetStateAction } from 'react'

import { CommonFormContextProps } from 'components/Form'
import { WorkspacePrebidConfiguration } from 'features/globalSetup/types/workspacePrebidConfiguration'

export const DefaultsPageContext = createContext<DefaultsPageContextType>(
  {} as DefaultsPageContextType,
)

export type DefaultsPageContextType = CommonFormContextProps & {
  prebid: {
    setWorkspaceConfig: Dispatch<SetStateAction<undefined | WorkspacePrebidConfiguration>>
    workspaceConfig?: WorkspacePrebidConfiguration
  }
}
